import {
  exists,
  UsageStatisticsCopy,
  UsageStatisticsCopyFromJSON,
  UsageStatisticsEvent,
  UsageStatisticsEventFromJSON,
  UsageStatisticsReference,
  UsageStatisticsReferenceFromJSON
} from '@/api'

export interface UsageStatistics {
  references: UsageStatisticsReference[]
  copies: UsageStatisticsCopy[]
  events: UsageStatisticsEvent[]
  revision: number | null
}

export const defaultUsageStatistics = (): UsageStatistics => ({
  references: [],
  copies: [],
  events: [],
  revision: 0
})

export function UsageStatisticsFromJSON(json: any): UsageStatistics {
  return {
    references: exists(json, 'references')
      ? json.references.map(UsageStatisticsReferenceFromJSON)
      : [],
    copies: exists(json, 'copies')
      ? json.copies.map(UsageStatisticsCopyFromJSON)
      : [],
    events: exists(json, 'events')
      ? json.events.map(UsageStatisticsEventFromJSON)
      : [],
    revision: exists(json, 'revision') ? json.revision : null
  }
}
